<template>
  <div v-if="isOpen" class="diy-modal" @keydown.esc="toggleModal">
    <div class="diy-modal__wrapper">
      <div class="diy-modal__content">
        <div v-if="settings.title" class="diy-modal__heading">
          <AppHeading tag="h4" :text="settings.title">
            <AppIcon v-if="settings.icon" :icon="settings.icon" />
          </AppHeading>
          <!-- close btn -->
          <DIYModalCloseButtton @close="toggleModal" />
        </div>
        <div class="diy-modal__inner">
          <component :is="settings.component" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const documentElement = document.documentElement
// Components
import AppIcon from 'Ui/AppIcon'
import AppHeading from 'Ui/AppHeading'
import DIYModalCloseButtton from './components/DIYModalCloseButton'
// Utilities
import { EventBus } from '@/main'

export default {
  name: 'DIYModal',

  components: {
    AppIcon,
    AppHeading,
    DIYModalCloseButtton,
    ProfileInfo: () => import('./components/ProfileInfo'),
    NewTemplateForm: () => import('Components/Forms/NewTemplateForm'),
  },

  data() {
    return {
      isOpen: false,
      loaded: false,
      settings: {
        title: '',
        component: '',
      },
    }
  },

  methods: {
    loadModal(modalSettings) {
      this.settings = modalSettings
      this.settings && this.toggleModal()
    },

    toggleModal() {
      // const appWrapper = document.querySelector('.v-main')
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        documentElement.classList.add('hideY')
        // appWrapper.classList.add('overlay-blur')
      }
      if (!this.isOpen) {
        documentElement.classList.remove('hideY')
        // appWrapper.classList.remove('overlay-blur')
      }
    },
  },
  created() {
    EventBus.$on('open-diy-modal', this.loadModal)
    EventBus.$on('close-diy-modal', this.toggleModal)
  },

  destroyed() {
    EventBus.$off('open-diy-modal', this.loadModal)
    EventBus.$off('close-diy-modal', this.toggleModal)
  },
}
</script>

<style scoped>
.diy-modal {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 100px 0;
  overflow-y: auto;
  background: var(--rgba-modal);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  z-index: 201;
}

.diy-modal__wrapper {
  display: flex;
  justify-content: center;
  position: relative;
  top: 0;
  width: calc(100vw - 40px);
  max-width: 600px;
  margin: 0 auto;
  /* transform: translateY(-50%); */
  z-index: 202;
}

.diy-modal__content {
  transform: scale(0);
  transform-origin: center;
  animation: animate-modal 0.4s forwards;
  animation-delay: 100ms;
}

.diy-modal__content {
  position: relative;
  width: 100%;
  border-radius: 4px;
  background: #fff;
}

.diy-modal__heading {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  color: var(--c-secondary-700);
  padding: 20px 20px 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.diy-modal__heading .app-heading {
  display: flex;
  align-items: center;
  position: relative;
  gap: 10px;
  font-size: 22px;
  font-weight: 400;
  color: inherit;
}

.diy-modal__heading .app-heading .app-icon {
  font-size: 18px;
}

.diy-modal__content-close >>> .app-button--icon {
  font-size: 18px;
  background-color: transparent;
}

.diy-modal__inner {
  padding: 30px 20px;
}

@keyframes animate-modal {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .diy-modal__content {
    width: 100%;
    min-width: unset;
  }

  .diy-modal__inner {
    padding: 20px 15px;
  }
}
</style>
